import { Http } from '../../services/Http';
import { PricingDataDTO } from '../../frameworks_drivers/dtos/PricingDataDTO';
import { PricingData } from '../../entities/model/PricingData';
import { PricingRequestDTO } from '../../frameworks_drivers/dtos/PricingRequestDTO';

export interface PricingDataSource {
  getPricingData(pricingRequestDTO: PricingRequestDTO): Promise<PricingData>;

  getFullPricingData(pricingRequestDTO: PricingRequestDTO): Promise<PricingData>;
}

export class PricingDataSourceImpl implements PricingDataSource {
  async getPricingData(pricingRequestDTO: PricingRequestDTO): Promise<PricingData> {
    const response = await Http.post<PricingDataDTO>('/api/prices', pricingRequestDTO);
    return this.mapToModel(response.data);
  }

  // TODO: Ensure that forceFullPrice is set
  async getFullPricingData(pricingRequestDTO: PricingRequestDTO): Promise<PricingData> {
    const response = await Http.post<PricingDataDTO>('/api/prices', pricingRequestDTO);
    return this.mapToModel(response.data);
  }

  mapToModel(dto: PricingDataDTO): PricingData {
    // TODO: Implement the mapping logic from DTO to model
    return dto;
  }
}
